<script>
export default {
  data () {
    return {
      customerCodeSet: [],
      customerNameSet: []
    }
  },
  methods: {
    loadCustomer () {
      this.$axios
        .get('/search-customer')
        .then((res) => {
          const result = res.data.list
          const customerCodeSet = new Set()
          const customerNameSet = new Set()
          result.forEach((x) => {
            customerCodeSet.add(x.customer_code)
            customerNameSet.add(x.customer_name)
          })
          this.customerCodeSet = [...customerCodeSet]
          this.customerNameSet = [...customerNameSet]
          sessionStorage.setItem('customerCodeSet', JSON.stringify(this.customerCodeSet))
          sessionStorage.setItem('customerNameSet', JSON.stringify([...this.customerNameSet]))
        })
        .catch((e) => {
          console.log(e)
        })
    },
    refreshAutocompleteList () {
      this.customerCodeSet = JSON.parse(sessionStorage.getItem('customerCodeSet'))
      this.customerNameSet = JSON.parse(sessionStorage.getItem('customerNameSet'))
    },
    getCustomerCodeSet () {
      return JSON.parse(sessionStorage.getItem('customerCodeSet'))
    },
    getCustomerNameSet () {
      return JSON.parse(sessionStorage.getItem('customerNameSet'))
    },
    margeCustomerCodeSet (value) {
      const newCustomerCodeSet = Array.isArray(value) ? [...value] : [value]
      const customerCodeSet = [...new Set([...JSON.parse(sessionStorage.getItem('customerCodeSet')),
        ...newCustomerCodeSet])].sort()
      sessionStorage.setItem('customerCodeSet', JSON.stringify([...customerCodeSet]))
    },
    margeCustomerNameSet (value) {
      const newCustomerNameSet = Array.isArray(value) ? [...value] : [value]
      const customerNameSet = [...new Set([...JSON.parse(sessionStorage.getItem('customerNameSet')),
        ...newCustomerNameSet])].sort()
      sessionStorage.setItem('customerNameSet', JSON.stringify([...customerNameSet]))
    }
  }
}
</script>
